import * as React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  Typography
} from '@mui/material';
import PropTypes from 'prop-types';
import { Icon } from '@iconify/react';
import trash2Outline from '@iconify/icons-eva/trash-2-outline';
import SnackbarAlert from '../common/SnackbarAlert';
import request from 'src/utils/request';
import { LoadingButton } from '@mui/lab';

DeleteAlert.propTypes = {
  deleteopen: PropTypes.bool,
  deleteData: PropTypes.object,
  closeDeleteModal: PropTypes.func
};

export default function DeleteAlert({
  deleteopen,
  deleteData,
  closeDeleteModal
}) {
  const [showSnackBarAlert, setShowSnackBarAlert] = React.useState({
    status: false,
    type: 'success',
    message: null
  });
  const [loader, setLoader] = React.useState(false);
  const deleteState = () => {
    setLoader(true);
    request({
      url: `documentName/${deleteData.id}`,
      method: 'delete',
      data: {
        id: deleteData.id,
        name: deleteData.name
      }
    })
      .then(
        // eslint-disable-next-line
        (data) => {
          if (data.status) {
            setLoader(false);
            closeDeleteModal(true);
            setShowSnackBarAlert({
              status: true,
              type: 'success',
              message: `${deleteData.name} Deleted`
            });
          } else {
            setLoader(false);
            setShowSnackBarAlert({
              status: true,
              type: 'error',
              message: data['message']
            });
          }
        }
      )
      .catch(
        function (err) {
          setLoader(false);
          console.log(err.message);
          // eslint-disable-next-line no-extra-bind
        }.bind(this)
      );
  };

  const handleSnackbarClose = () => {
    setShowSnackBarAlert({ status: false, type: null, message: null });
  };

  return (
    <>
      <Dialog
        open={deleteopen}
        onClose={() => closeDeleteModal(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title" style={{ textAlign: 'left' }}>
          {' '}
          <Grid
            container
            direction="row"
            justifyContent="left"
            alignItems="stretch"
            spacing={1}
          >
            <Grid style={{ textAlign: 'left' }} sx={{mt:2}}>
              <Icon
                icon={trash2Outline}
                width={22}
                height={22}
                color="red"
                style={{ textAlign: 'left' }}
              />
              &nbsp;&nbsp;&nbsp;
            </Grid>
            <Grid sx={{mt:2}}>
              <Typography
                variant="h6"
                color="black"
                style={{ textAlign: 'left' }}
              >
                Delete Document Name
              </Typography>
            </Grid>
          </Grid>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to delete{' '}
            {deleteData ? deleteData.groupName : null} ?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <LoadingButton
            sx={{ mt: { xs: 2, md: 0 } }}
            loading={loader}
            variant="contained"
            type="submit"
            color="error"
            onClick={deleteState}
            autoFocus
          >
            Delete
          </LoadingButton>

          {/* <Button color="error" onClick={deleteState} variant="contained">
            Delete
          </Button> */}
          <Button
            onClick={() => closeDeleteModal(false)}
            variant="contained"
            color="primary"
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
      <SnackbarAlert
        showSnackBarAlert={showSnackBarAlert}
        handleSnackbarClose={handleSnackbarClose}
      />
    </>
  );
}
